module.exports = __webpack_public_path__ + "static/img/kitchen3-thumb.4251e7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/kitchen3-thumb.jpg
// module id = t9BY
// module chunks = 0